var _path, _g, _path2, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_55565_36843",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 17,
    height: 17
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.66602 1.66675H17.8967V17.8976H1.66602V1.66675Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_55565_36843)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.78185 2.91675C5.99602 2.91675 2.91602 5.99591 2.91602 9.78175C2.91602 13.5676 5.99602 16.6476 9.78185 16.6476C13.5668 16.6476 16.6468 13.5676 16.6468 9.78175C16.6468 5.99591 13.5668 2.91675 9.78185 2.91675ZM9.78185 17.8976C5.30685 17.8976 1.66602 14.2567 1.66602 9.78175C1.66602 5.30675 5.30685 1.66675 9.78185 1.66675C14.2568 1.66675 17.8968 5.30675 17.8968 9.78175C17.8968 14.2567 14.2568 17.8976 9.78185 17.8976Z",
    fill: "#A1A1AA"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_55565_36843",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 14,
    width: 5,
    height: 5
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3652 14.7559H18.5519V18.9348H14.3652V14.7559Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_55565_36843)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9271 18.9348C17.7679 18.9348 17.6079 18.874 17.4854 18.7523L14.5488 15.824C14.3046 15.5798 14.3038 15.184 14.5479 14.9398C14.7913 14.694 15.1871 14.6957 15.4321 14.9382L18.3688 17.8673C18.6129 18.1115 18.6138 18.5065 18.3696 18.7507C18.2479 18.874 18.0871 18.9348 17.9271 18.9348Z",
    fill: "#A1A1AA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.a60497ade8fa6c5db8768c67492a122b.svg";
export { ForwardRef as ReactComponent };